<template>
  <div v-if="validated && status === 'success'">
    <b-card class="text-center border border-danger">
      <h3 class="fs-2 fw-bold">
        {{ message }}<br><br>
        For free full access to the FVC Structured Edge Research Service please visit
        <router-link to="/" class="text-primary text-decoration-underline">
          our website.
        </router-link>
      </h3>
    </b-card>

    <product-breakdown
      :report-flavour="'bespoke'"
      :fvcdetailsid = this.$route.params.fvcdetailsid
      :supplied-password = this.$route.params.linkpassword
    />
  </div>
  <div v-else>
    <b-card class="text-center border border-danger">
      <h3 class="fs-2 fw-bold">
        {{ message }}
      </h3>
    </b-card>
  </div>
</template>

<script>

import ProductBreakdown from '@/views/products/ProductBreakdown.vue'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'PrivateReport',
  components: {
    ProductBreakdown,
    BCard,
  },
  data() {
    return {
      validated: false,
      status: '',
      message: '',
    }
  },
  created() {
    this.checkUrlPassword()
  },
  methods: {
    checkUrlPassword() {
      const { fvcdetailsid, linkpassword } = this.$route.params

      this.$http.get('reportflavours.cfc', {
        params: {
          method: 'validateUrlPassword',
          flavour: 'bespoke',
          fvcdetailsid,
          urlpassword: linkpassword,
        },
      })
        .then(response => {
          const { data } = response
          if (data.STATUS === 'success') {
            this.validated = true
            this.status = data.STATUS
            this.message = data.MESSAGE
          } else if (data.STATUS === 'partial') {
            this.status = data.STATUS
            this.message = data.MESSAGE
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' })
        })
    },
  },
}
</script>
